import { add } from 'lodash';

export const selectAd = (ads, user) => {
  const dateOfBirth = user.dateOfBirth?.toDate();
  const age = getAge(dateOfBirth);

  if (
    !['guest', 'customer'].includes(user?.role) ||
    ['pro'].includes(user?.plan)
  ) {
    return null;
  }
  const filteredAds = ads.filter(ad => {
    if (ad.location !== user?.location) {
      return false;
    }
    if (ad.gender !== 'all' && ad.gender !== user?.gender) {
      return false;
    }
    if (
      (age && add.ageRange && ad.ageRange[0] > age) ||
      (add.ageRange && ad.ageRange[1] < age)
    ) {
      return false;
    }
    if (ad.status !== 'all' && ad.status !== user?.status) {
      return false;
    }

    return true;
  });
  let ad = getRandomItem(filteredAds);
  if (!ad) {
    ad = getRandomItem(ads);
  }
  return ad;
};

const getRandomItem = arr => arr[Math.floor(Math.random() * arr.length)];

function getAge(dateString) {
  try {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  } catch (e) {
    return undefined;
  }
}
